import React from "react";

import { QueryParamProvider } from "use-query-params";
import { ReachAdapter } from "use-query-params/adapters/reach";

const withQueryParams = ComponentToWrap => props => (
  <QueryParamProvider adapter={ReachAdapter}>
    <ComponentToWrap
     {...props}
     />  
  </QueryParamProvider>
)

export default withQueryParams;